import { PIX_DID_GENERATE, GENERATING_PIX, PIX_ERROR } from 'actions'

export function pix(
  state = {
    isFetching: false,
    generated: false,
  },
  action,
) {
  switch (action.type) {
    case PIX_DID_GENERATE:
      return {
        ...state,
        ...action.data,
        isFetching: false,
        generated: true,
      }

    case PIX_ERROR:
      return {
        ...state,
        ...action.data,
        isFetching: false,
        generated: false,
      }

    case GENERATING_PIX:
      return {
        ...state,
        isFetching: true,
      }

    default:
      return state
  }
}

export default pix
